import "./AdminHeader.scss";
import moment from "moment";
import Logo from "./Svg/Logo";
import { nanoid } from "nanoid";
import { Typography } from "antd";
import Button from "../../Button";
import Modal from "react-bootstrap/Modal";
import constants from "../../../constants";
import { getDataFromStorage } from "../../../util";
import TestSvgIcon from "../../../Svg/TestSvgIcon";
import { Link, useLocation } from "react-router-dom";
import MenuDropDown from "../Dashboard/MenuDropDown";
import Overlay from "../../CommonComponents/Overlay";
import ZoomAdminView from "../../Zoom/ZoomAdminView";
import AdminHeaderHooks from "./Hooks/AdminHeaderHooks";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import React, { useEffect, useContext, useState } from "react";
import ProfileAvatar from "../../CommonComponents/ProfileAvatar";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import CompanyDropDown from "../../CommonComponents/CompanyDropDown";
import Tooltip from "../../CommonComponents/Tooltip";
import { LibraryContext } from "../../../context/LibraryContext";
import { useNavigate } from "react-router-dom";
function AdminHeader() {
  const Alert = useContext(AlertContext);
  const LibraryCxt = useContext(LibraryContext);

  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/universitysettings"); // Replace "/target-page" with your desired route
  };

  const {
    ref,
    details,
    libType,
    setLibType,
    setIsNotifyOpened,
    clearQuestionNotify,
    setClearQuestionNotify,
    setNotificationDetails,
  } = AdminHeaderHooks();

  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();

  const { pathname, search } = useLocation();
  const [showLive, setShowLive] = useState(false);
  const [batchName, setBatchName] = useState(null);
  const [selectedMenuKey, setSelectedMenuKey] = useState(null);

  const notificationReport = async (row, lid, notificationid, isread) => {
    if (row.tag === "ACTION" && isread === 0) {
      setClearQuestionNotify({
        isClear: true,
        notificationid: notificationid,
        lpid: row.notificationData.lpid,
        testid: row.notificationData.testid,
        topicid: row.notificationData.topicid,
        libType: row.notificationData.libtype,
        sectionid: row.notificationData.secid,
        moduleid: row.notificationData.moduleid,
        learnerid: row.notificationData.learnerid,
        learnerName: `${row.notificationData.firstname + " " + row.notificationData.lastname
          }`,
      });
    } else if (row.tag === "INFO") {
      await handleMarkAllAsRead(notificationid, true);
    } else
      document.querySelector(".notifications .container").style.visibility =
        "hidden";
  };

  const handleMarkAllAsRead = (notificationId, istrue) => {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "node/learner/notification/read",
          istrue
            ? JSON.stringify({
              notificationid: notificationId,
              userid: getDataFromStorage("learnerid"),
            })
            : JSON.stringify({ userid: getDataFromStorage("learnerid") }),
          {
            headers: {
              "Content-type": "application/json",
            },
          },
        )
        .then((response) => {
          let jsonArr = [];

          for (let i = 0; i < details.current.length; i++) {
            if (notificationId === "") details.current[i].isread = 1;
            else {
              if (notificationId === details.current[i].notificationid) {
                details.current[i].isread = 1;
              }
            }

            let data = JSON.parse(details.current[i].data);
            let json = {
              id: nanoid(),
              key: nanoid(),
              message: (
                <div key={nanoid()}>
                  <span
                    className="adminNotificationUnReadDot"
                    style={
                      details.current[i].isread === 1
                        ? { display: "none" }
                        : {
                          width: "5px",
                          float: "left",
                          height: "5px",
                          borderRadius: "50%",
                          background: "#0D6EFD",
                          margin: "15px 5px 0 0",
                        }
                    }
                  ></span>
                  <div className="adminNotificationUserImg">
                    {data.hasOwnProperty("firstname") &&
                      data.hasOwnProperty("lastname")
                      ? data.firstname.charAt(0).toUpperCase() +
                      data.lastname.charAt(0).toUpperCase()
                      : ""}
                  </div>
                  <p
                    className="adminNotificationMsg"
                    onClick={() => {
                      notificationReport(
                        {
                          notificationData: data,
                          tag: details.current[i].tag,
                        },
                        details.current[i].userid,
                        details.current[i].notificationid,
                        details.current[i].isread,
                      );
                    }}
                  >
                    {details.current[i].message}
                  </p>
                </div>
              ),

              receivedTime: moment(details.current[i].timestamp).fromNow(),
            };

            jsonArr.push(json);
          }

          jsonArr = jsonArr.reverse();
          setNotificationDetails(jsonArr);
          resolve("Success");
        })
        .catch((err) => {
          reject("Failure");
        });
    });
  };

  const handleLearnigpathClick = (name) => {
    if (name === "profiles") {
      Alert.isFromProfile.current = true;
    } else {
      Alert.isFromProfile.current = false;
    }

    Alert.setLpData2({
      cMId: 0,
      type: 1,
      lpDes: "",
      lpName: "",
      lpIcon: "",
      status: "",
      archived: 0,
      id: nanoid(),
      moduleId: "",
      libTypeId: 2,
      lpContent: "",
      lpShortDes: "",
      iconFileName: "",
      isAddTest: false,
      parentModules: [
        {
          name: "",
          description: "",
        },
      ],
      modules: [
        {
          id: 1,
          key: nanoid(),
          status: "new",
          moduleName: "",
          moduleData: [],
        },
      ],
    });

    Alert.setIsAddLp(false);
    Alert.setIsFromLp(false);
    Alert.setIsFromBatch(false);
    Alert.setselectque([]);
    Alert.setIsOldLpDetail(false);
    Alert.setIsAddLpModule(false);
  };

  const gettingSelectedDd = (
    name,
    id,
    type,
    isVideoQns = false,
    isAiInterview = false,
  ) => {
    console.log("name, id, type,isVideoQns:", name, id, type, isVideoQns);

    Alert.setChangeHeaderValue(true);
    Alert.isFromProfile.current = false;

    if (Alert.isCodingChallenge) Alert.setIsCodingChallenge(false);

    // if (type === "test") {
    //   Alert.setIsFromBatch(false);
    //   Alert.setIsAddLpModule(false);
    //   Alert.setIsOldLpDetail(false);

    //   Alert.setOldTestConfig({
    //     oldTestData: {},
    //     isOldTestConfig: false,
    //   });

    //   Alert.setLpData2({
    //     cMId: 0,
    //     type: 1,
    //     lpDes: "",
    //     lpName: "",
    //     lpIcon: "",
    //     status: "",
    //     moduleId: "",
    //     id: nanoid(),
    //     lpContent: "",
    //     libTypeId: id,
    //     lpShortDes: "",
    //     iconFileName: "",
    //     isAddTest: false,
    //     parentModules: [
    //       {
    //         name: "",
    //         description: "",
    //       },
    //     ],
    //     modules: [
    //       {
    //         id: 1,
    //         key: nanoid(),
    //         status: "new",
    //         moduleName: "",
    //         moduleData: [],
    //       },
    //     ],
    //   });
    //   let queryString = ``;
    //   if (+id === 3) {
    //     if (isVideoQns) {
    //       queryString = "?isVideoQns=true";
    //     } else {
    //       queryString = "?isVideoQns=false";
    //     }
    //   }
    //   Alert.setFromMenu(true);
    //   Alert.setFromMenuToEditTest(true);
    //   Alert.navigate(`/library/${id}/testlist${queryString}`);
    // } else {
    Alert.setFromList({ isFromList: false, libType: "" });
    Alert.setIsFromBatch(false);
    Alert.setSelectedLibType(name);
    Alert.setTableShowStatus(id);
    Alert.setCurrentPage(1);
    Alert.setselectque([]);
    Alert.setIsFromLp(false);
    Alert.setIsAddLp(false);
    Alert.setIsFromBatch(false);
    Alert.setIsAddLpModule(false);
    Alert.setIsOldLpDetail(false);
    LibraryCxt.setSearchText("");
    LibraryCxt.setSelectedTopic({
      id: "",
      name: "",
      value: "",
    });

    // if (
    //   parseInt(getDataFromStorage("accountType")) ===
    //   constants.ACCOUNT_USAGE_TYPE.CLIENT_EVAL
    // )
    //   Alert.navigate(`/library/${id}/shared`);
    // else
    const queryString = `${isVideoQns ? "?isVideoInterview=true" : isAiInterview ? "?isAiInterview=true" : ""}`

    if (
      [
        constants.libTypeIds.ASSIGNMENT,
        constants.libTypeIds.CONTENT,
      ].includes(id) ||
      parseInt(getDataFromStorage("companyId")) ===
      constants.GRADIOUS_ACCOUNT_ID
    )
      Alert.navigate(`/library/${id}/questionlist${queryString}`);
    //for gradious navigate to the question list
    else Alert.navigate(`/library/${id}/shared${queryString}`);
    // }
  };

  const handleMockTest = () => {
    Alert.setLists([]);
    Alert.setChangeHeaderValue(true);

    Alert.setIsFromBatch(false);
    Alert.setIsAddLpModule(false);
    Alert.setIsOldLpDetail(false);
    Alert.setOldTestConfig({
      oldTestData: {},
      isOldTestConfig: false,
    });
    Alert.setLpData2({
      cMId: 0,
      type: 1,
      lpDes: "",
      lpName: "",
      lpIcon: "",
      status: "",
      moduleId: "",
      id: nanoid(),
      lpContent: "",
      lpShortDes: "",
      isAddTest: false,
      iconFileName: "",
      parentModules: [
        {
          name: "",
          description: "",
        },
      ],
      modules: [
        {
          id: 1,
          key: nanoid(),
          status: "new",
          moduleName: "",
          moduleData: [],
        },
      ],
    });
    Alert.setFromMenu(true);
    Alert.setFromMenuToEditTest(true);
    Alert.navigate("/library/mock/test");
  };

  const handleMockLearnigPath = () => {
    Alert.setLists([]);
    Alert.setLpData2({
      cMId: 0,
      type: 1,
      lpDes: "",
      lpName: "",
      lpIcon: "",
      status: "",
      archived: 0,
      id: nanoid(),
      moduleId: "",
      libTypeId: 2,
      lpContent: "",
      lpShortDes: "",
      iconFileName: "",
      isAddTest: false,
      parentModules: [
        {
          name: "",
          description: "",
        },
      ],
      modules: [
        {
          id: 1,
          key: nanoid(),
          status: "new",
          moduleName: "",
          moduleData: [],
        },
      ],
    });
    Alert.setIsAddLp(false);
    Alert.setIsFromLp(false);
    Alert.setIsFromBatch(false);
    Alert.setselectque([]);
    Alert.setIsOldLpDetail(false);
    Alert.setIsAddLpModule(false);

    Alert.navigate("mock/learningpath");
  };

  const handleClearQuestion = () => {
    Alert.setIsLoaded(true);
    axios
      .post(
        process.env.REACT_APP_NODE_API + "node/admin/test/clearQuestions",
        JSON.stringify({
          lpid: clearQuestionNotify.lpid,
          testid: clearQuestionNotify.testid,
          topicid: clearQuestionNotify.topicid,
          moduleid: clearQuestionNotify.moduleid,
          libtypeid: clearQuestionNotify.libType,
          learnerid: clearQuestionNotify.learnerid,
          sectionid: clearQuestionNotify.sectionid,
        }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("tokenKey"),
          },
        },
      )
      .then(async (res) => {
        Alert.setIsLoaded(false);

        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          await handleMarkAllAsRead(clearQuestionNotify.notificationid, true);
          Alert.setShowNotify({
            show: true,
            title: "Success",
            msg: res.data.data,
          });
          setClearQuestionNotify({ isClear: false, learnerName: "" });
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Warning",
            msg: "Network error",
          });
        }
      })
      .catch((err) => {
        Alert.setIsLoaded(false);
      });
  };

  const getSelectedMenuKeyFromUrl = () => {
  const queryParams = new URLSearchParams(search);

  // Mock URL: /library/mock/test
  if (pathname.includes("/library/mock")) {
    return "mock";
  }

  // Video URL: /library/3/questionlist?isVideoInterview=true
  if (queryParams.get("isVideoInterview") === "true") {
    return "video-interview";
  }

  // AI URL: /library/3/questionlist?isAiInterview=true
  if (queryParams.get("isAiInterview") === "true") {
    return "ai-interview";
  }

  // Normal library types, such as Coding Challenge: /library/5/questionlist
  return Number(pathname.split("/")[2]) || null;
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsNotifyOpened(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setIsNotifyOpened]);

  useEffect(() => {
    if (
      pathname.includes("/batches") &&
      pathname.match(/^\/[^/]+\/[^/]+\/(.*)/)
    )
      setBatchName(Alert.batchDetails?.name);
    else setBatchName(null);
  }, [pathname, Alert.batchDetails]);

  useEffect(() => {
    if (getDataFromStorage("role") !== constants.Roles.evaluator) {
      axios
        .get("node/admin/library/gettypes", {
          headers: {
            "Content-type": "application/json",
          },
        })
        .then((res) => {
          let json = res.data.filter((data) => data.parenttype === 0);

          Alert.setSelectedLibType(json[0].name);
          Alert.setTableShowStatus(json[0].id);
          setLibType(json);
          // setSelectedMenuKey(json[0].id);
          setSelectedMenuKey(getSelectedMenuKeyFromUrl() || json[0].id);
        });
    }
  }, []);

  useEffect(() => {
  setSelectedMenuKey(getSelectedMenuKeyFromUrl());
}, [pathname, search]);

  return (
    <>
      <div className="Header">
        <div id="adminHeaderLogo">
          <div className="adminHeaderLogoWithVersion">
            <div>
              <Logo
                setBatchDetails={Alert.setBatchDetails}
                setIsBatchDetails={Alert.setIsBatchDetails}
              />
            </div>
          </div>

          {batchName &&
            batchName !== "" &&
            pathname.includes("/batches") &&
            pathname.match(/^\/[^/]+\/[^/]+\/(.*)/) && (
              <Tooltip title={batchName} className="adminHeaderBatchName">
                <span>
                  <span className="adminHeaderBatchNameSlash">/</span>{" "}
                  {batchName}
                </span>
              </Tooltip>
            )}
        </div>
        {pathname !== "/sandpack" && (
          <div className="Pages">
            {getDataFromStorage("role") !== constants.Roles.tutor &&
              getDataFromStorage("role") !== constants.Roles.creator &&
              getDataFromStorage("role") !== constants.Roles.evaluator &&
              getDataFromStorage("role") !== constants.Roles.evaluator &&
              getDataFromStorage("role") !== constants.Roles.hr &&
              localStorage.getItem("university_type") != constants.ACCOUNT_TYPE.CORPORATE && ( // no dashbaord for hr
                <div className="Page">
                  {getDataFromStorage("role") !== constants.Roles.customer &&
                    localStorage.getItem("university_type") !== "2" && (
                      <Link
                        id="dashboard"
                        to="/university-dashboard"
                        className={`dashboard ${pathname.includes("university-dashboard")
                          ? "active"
                          : ""
                          }`}
                      >
                        DASHBOARD
                      </Link>
                      // <MenuDropDown />
                    )}
                </div>
              )}

            <div className="Page">
              {getDataFromStorage("role") !== constants.Roles.customer &&
                getDataFromStorage("role") !== constants.Roles.creator && (
                  <Link
                    id="live"
                    to={"/batches"}
                    onClick={() => {
                      useCommonFunctionHks.handleClose();
                      Alert.setIsBatchDetails(false);
                      Alert.setBatchDetails([]);
                      Alert.isFromProfile.current = false;
                    }}
                    className={`live ${pathname.includes("/batches") ? "active" : ""
                      }`}
                  >
                    Batches
                  </Link>
                )}
            </div>

            {getDataFromStorage("role") !== constants.Roles.hr &&
              getDataFromStorage("role") !== constants.Roles.customer &&
              getDataFromStorage("role") !== constants.Roles.tutor &&
              getDataFromStorage("role") !== constants.Roles.creator &&
              getDataFromStorage("role") !== constants.Roles.evaluator && (
                <div className="Page">
                  <Link
                    id="learningPaths"
                    to="/learningpath"
                    onClick={() => {
                      handleLearnigpathClick("learningpath");
                    }}
                    className={`learningPaths ${pathname.includes("/learningpath") ? "active" : ""
                      }`}
                  >
                    PATHS
                  </Link>
                </div>
              )}

            {getDataFromStorage("role") !== constants.Roles.hr &&
              getDataFromStorage("role") !== constants.Roles.customer &&
              getDataFromStorage("role") !== constants.Roles.tutor &&
              getDataFromStorage("role") !== constants.Roles.creator &&
              getDataFromStorage("role") !== constants.Roles.evaluator &&
              parseInt(getDataFromStorage("companyId")) ===
              constants.GRADIOUS_ACCOUNT_ID && (
                <>
                  <div className="Page">
                    <Link
                      id="jobs"
                      to="/jobs"
                      className={`jobs ${pathname === "/jobs" ? "active" : ""}`}
                      onClick={() => {
                        Alert.navigate("/jos");
                        Alert.isFromProfile.current = false;
                      }}
                    >
                      JOBS
                    </Link>
                  </div>
                  <div className="Page">
                    <Link
                      id="hackathons"
                      to="/hackathons"
                      onClick={() => (Alert.isFromProfile.current = false)}
                      className={`hackathons ${pathname === "/hackathons" ? "active" : ""
                        }`}
                    >
                      HACKATHONS
                    </Link>
                  </div>
                </>
              )}
            {getDataFromStorage("role") !== constants.Roles.hr &&
              getDataFromStorage("role") !== constants.Roles.customer &&
              getDataFromStorage("role") !== constants.Roles.evaluator && (
                <div className="Page">
                  <div
                    id="questions"
                    className={`questions ${pathname.includes("/library") ||
                      pathname.includes("/mock")
                      ? "active"
                      : ""
                      }`}
                  >
                    LIBRARY
                    <div className="headerDropdownContent">
                      {getDataFromStorage("role") === constants.Roles.tutor ? (
                        <p
                          key={nanoid()}
                          value={"Content"}
                          className="libtypediv"
                          onClick={() =>
                            gettingSelectedDd(
                              "Content",
                              constants.libTypeIds.id,
                            )
                          }
                        >
                          <TestSvgIcon
                            active={true}
                            disable={true}
                            libType={constants.libTypeIds.id}
                          />
                          {"Content Editor"}
                        </p>
                      ) : (
                        libType.map((data) => (
                          <p
                            key={nanoid()}
                            value={data.name}
                            className={`libtypediv ${selectedMenuKey === data.id ? "libtypediv-active" : ""}`}
                            onClick={() => {
                              gettingSelectedDd(data.name, data.id);
                              setSelectedMenuKey(data.id)
                            }
                            }
                          >
                            <span className="libtypediv-left">
                              <TestSvgIcon
                                active={true}
                                disable={true}
                                libType={data.id}
                              />
                              {data.name === "Content"
                                ? "Content Editor"
                                : data.name}
                            </span>

                            {selectedMenuKey === data.id && (
                              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                  stroke="#F55533"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            )}
                          </p>
                        ))
                      )}
                      {/* <p
                        className="libtypediv"
                        onClick={() =>
                          gettingSelectedDd(
                            "",
                            constants.libTypeIds.DESCRIPTIVE,
                            undefined,
                            true,
                          )
                        }
                      >
                        <TestSvgIcon
                          active={true}
                          disable={false}
                          libType={constants.libTypeIds.DESCRIPTIVE}
                          videoQn={true}
                        />
                        {"  "}
                        Video Interview{" "}
                      </p> */}

                      <p
                        // className="libtypediv"
                        className={`libtypediv ${selectedMenuKey === "video-interview" ? "libtypediv-active" : ""}`}
                        onClick={() => {
                          gettingSelectedDd
                            (
                              "",
                              constants.libTypeIds.DESCRIPTIVE,
                              undefined,
                              true,
                            );
                          setSelectedMenuKey("video-interview");
                        }}
                      >
                        <span className="libtypediv-left">
                          <TestSvgIcon
                            active={true}
                            disable={false}
                            libType={constants.libTypeIds.DESCRIPTIVE}
                            videoQn={true}
                          />
                          Video Interview
                        </span>
                        {selectedMenuKey === "video-interview" && (
                          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F55533" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        )}

                      </p>
                      {/* <p
                        className="libtypediv"
                        onClick={() =>
                          gettingSelectedDd(
                            "",
                            constants.libTypeIds.DESCRIPTIVE,
                            undefined,
                            false,
                            true,
                          )
                        }
                      >
                        <TestSvgIcon
                          active={true}
                          disable={false}
                          libType={constants.libTypeIds.DESCRIPTIVE}
                          aiInterview={true}
                        />
                        {"  "}
                        Ai Interview{" "}
                      </p> */}

                      <p
                        className={`libtypediv ${selectedMenuKey === "ai-interview" ? "libtypediv-active" : ""}`}
                        onClick={() => {
                          gettingSelectedDd("", constants.libTypeIds.DESCRIPTIVE, undefined, false, true);
                          setSelectedMenuKey("ai-interview");
                        }}
                      >
                        <span className="libtypediv-left">
                          <TestSvgIcon active={true} disable={false} libType={constants.libTypeIds.DESCRIPTIVE} aiInterview={true} />
                          Ai Interview
                        </span>
                        {selectedMenuKey === "ai-interview" && (
                          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F55533" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        )}
                      </p>
                      {/* {parseInt(getDataFromStorage("companyId")) ===
                        constants.GRADIOUS_ACCOUNT_ID && (
                          <p
                            className="libtypediv"
                            onClick={() => {
                              handleMockTest();
                              Alert.isFromProfile.current = false;
                            }}
                          >
                            <TestSvgIcon
                              active={true}
                              disable={false}
                              libType={constants.libTypeIds.TEST}
                            />
                            Mock
                          </p>
                        )} */}

                      {parseInt(getDataFromStorage("companyId")) === constants.GRADIOUS_ACCOUNT_ID && (
                        <p
                          className={`libtypediv ${selectedMenuKey === "mock" ? "libtypediv-active" : ""}`}
                          onClick={() => {
                            handleMockTest();
                            Alert.isFromProfile.current = false;
                            setSelectedMenuKey("mock");
                          }}
                        >
                          <span className="libtypediv-left">
                            <TestSvgIcon active={true} disable={false} libType={constants.libTypeIds.TEST} />
                            Mock
                          </span>
                          {selectedMenuKey === "mock" && (
                            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#F55533" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          )}
                        </p>
                      )}
                      {/* {getDataFromStorage("role") !== constants.Roles.hr &&
                        getDataFromStorage("role") !==
                        constants.Roles.customer &&
                        getDataFromStorage("role") !== constants.Roles.tutor &&
                        getDataFromStorage("role") !==
                        constants.Roles.creator && (
                          <>
                            <Typography id="libraryTestTitle">Tests</Typography>
                            <p
                              className="libtypediv"
                              onClick={() =>
                                gettingSelectedDd(
                                  "",
                                  constants.libTypeIds.MCQ,
                                  "test",
                                )
                              }
                            >
                              <TestSvgIcon
                                active={true}
                                disable={false}
                                libType={constants.libTypeIds.MCQ}
                              />
                              {"  "}
                              Multiple Choice Question{" "}
                            </p>
                            <p
                              className="libtypediv"
                              onClick={() =>
                                gettingSelectedDd(
                                  "",
                                  constants.libTypeIds.DESCRIPTIVE,
                                  "test",
                                  false
                                )
                              }
                            >
                              <TestSvgIcon
                                active={true}
                                disable={false}
                                libType={constants.libTypeIds.DESCRIPTIVE}
                              />
                              Descriptive
                            </p>
                            <p
                              className="libtypediv"
                              onClick={() =>
                                gettingSelectedDd(
                                  "",
                                  constants.libTypeIds.CODING_SNIPPET,
                                  "test",
                                )
                              }
                            >
                              <TestSvgIcon
                                active={true}
                                disable={false}
                                libType={constants.libTypeIds.CODING_SNIPPET}
                              />
                              Coding Snippet
                            </p>
                            {
                              getDataFromStorage("companyId") == 1 && (
                                <p
                                  className="libtypediv"
                                  onClick={() =>
                                    gettingSelectedDd(
                                      "",
                                      constants.libTypeIds.DESCRIPTIVE,
                                      "test",
                                      true
                                    )
                                  }
                                >
                                  <TestSvgIcon
                                    active={true}
                                    disable={false}
                                    libType={constants.libTypeIds.DESCRIPTIVE}
                                  />
                                  Video Tests
                                </p>
                              )
                            }
                            <p
                              className="libtypediv"
                              onClick={() =>
                                gettingSelectedDd(
                                  "",
                                  constants.libTypeIds.CODING_CHALLENGE,
                                  "test",
                                )
                              }
                            >
                              <TestSvgIcon
                                active={true}
                                disable={false}
                                libType={constants.libTypeIds.CODING_CHALLENGE}
                              />
                              Coding Challenge
                            </p>
                            <p
                              className="libtypediv"
                              onClick={() =>
                                gettingSelectedDd(
                                  "",
                                  constants.libTypeIds.SQL,
                                  "test",
                                )
                              }
                            >
                              <TestSvgIcon
                                active={true}
                                disable={false}
                                libType={constants.libTypeIds.SQL}
                              />
                              SQL
                            </p>
                            {parseInt(getDataFromStorage("companyId")) ===
                              constants.GRADIOUS_ACCOUNT_ID && (
                                <p
                                  className="libtypediv"
                                  onClick={() => {
                                    handleMockTest();
                                    Alert.isFromProfile.current = false;
                                  }}
                                >
                                  <TestSvgIcon
                                    active={true}
                                    disable={false}
                                    libType={constants.libTypeIds.TEST}
                                  />
                                  Mock
                                </p>
                              )}
                          </>
                        )} */}
                    </div>
                  </div>
                </div>
              )}
            {getDataFromStorage("role") !== constants.Roles.hr &&
              getDataFromStorage("role") !== constants.Roles.customer &&
              getDataFromStorage("role") !== constants.Roles.tutor &&
              getDataFromStorage("role") !== constants.Roles.creator &&
              getDataFromStorage("role") !== constants.Roles.evaluator &&
              parseInt(getDataFromStorage("companyId")) === 1 && (
                <>
                  <div className="Page">
                    <Link
                      to="/profiles"
                      id="learningPaths"
                      onClick={() => {
                        handleLearnigpathClick("profiles");
                      }}
                      className={`learningPaths ${pathname === "/profiles" ? "active" : ""
                        }`}
                    >
                      PROFILES
                    </Link>
                  </div>
                </>
              )}
            {getDataFromStorage("role") !== constants.Roles.hr &&
              getDataFromStorage("role") !== constants.Roles.customer &&
              getDataFromStorage("role") !== constants.Roles.tutor &&
              getDataFromStorage("role") !== constants.Roles.evaluator &&
              getDataFromStorage("role") !== constants.Roles.creator &&
              getDataFromStorage("role") !== constants.Roles.trainer && (
                <>
                  <div className="Page">
                    <Link
                      to="/users"
                      id="usersPage"
                      // onClick={() => {
                      //   handleLearnigpathClick("users");
                      // }}
                      className={`learningPaths ${pathname === "/users" ? "active" : ""
                        }`}
                    >
                      Users
                    </Link>
                  </div>
                </>
              )}
          </div>
        )}

        <div className="adminHeaderRightSec">
          {getDataFromStorage("role") === constants.Roles.super_admin && (
            <button
              onClick={handleNavigation}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
              }}
              aria-label="Navigate to target page"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_4663_6640)">
                  <path
                    d="M10 12.4997C11.3808 12.4997 12.5 11.3804 12.5 9.99967C12.5 8.61896 11.3808 7.49967 10 7.49967C8.61933 7.49967 7.50004 8.61896 7.50004 9.99967C7.50004 11.3804 8.61933 12.4997 10 12.4997Z"
                    stroke="#667085"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.1667 12.4997C16.0558 12.751 16.0227 13.0298 16.0717 13.3002C16.1207 13.5705 16.2496 13.8199 16.4417 14.0163L16.4917 14.0663C16.6467 14.2211 16.7696 14.4049 16.8535 14.6073C16.9373 14.8096 16.9805 15.0265 16.9805 15.2455C16.9805 15.4645 16.9373 15.6814 16.8535 15.8837C16.7696 16.0861 16.6467 16.2699 16.4917 16.4247C16.3369 16.5796 16.1531 16.7026 15.9508 16.7864C15.7484 16.8703 15.5316 16.9135 15.3125 16.9135C15.0935 16.9135 14.8766 16.8703 14.6743 16.7864C14.472 16.7026 14.2882 16.5796 14.1334 16.4247L14.0834 16.3747C13.887 16.1826 13.6375 16.0537 13.3672 16.0047C13.0969 15.9557 12.8181 15.9887 12.5667 16.0997C12.3202 16.2053 12.11 16.3807 11.962 16.6043C11.8139 16.8279 11.7344 17.0899 11.7334 17.358V17.4997C11.7334 17.9417 11.5578 18.3656 11.2452 18.6782C10.9327 18.9907 10.5087 19.1663 10.0667 19.1663C9.62468 19.1663 9.20076 18.9907 8.8882 18.6782C8.57564 18.3656 8.40004 17.9417 8.40004 17.4997V17.4247C8.39359 17.1488 8.30431 16.8813 8.1438 16.6569C7.98329 16.4325 7.75899 16.2616 7.50004 16.1663C7.24869 16.0554 6.96988 16.0223 6.69955 16.0713C6.42922 16.1204 6.17977 16.2492 5.98337 16.4413L5.93337 16.4913C5.77859 16.6463 5.59477 16.7692 5.39244 16.8531C5.19011 16.937 4.97323 16.9802 4.75421 16.9802C4.53518 16.9802 4.3183 16.937 4.11597 16.8531C3.91364 16.7692 3.72983 16.6463 3.57504 16.4913C3.42008 16.3366 3.29715 16.1527 3.21327 15.9504C3.1294 15.7481 3.08623 15.5312 3.08623 15.3122C3.08623 15.0931 3.1294 14.8763 3.21327 14.6739C3.29715 14.4716 3.42008 14.2878 3.57504 14.133L3.62504 14.083C3.81715 13.8866 3.94603 13.6372 3.99504 13.3668C4.04406 13.0965 4.01097 12.8177 3.90004 12.5663C3.7944 12.3199 3.619 12.1097 3.39543 11.9616C3.17185 11.8135 2.90986 11.7341 2.64171 11.733H2.50004C2.05801 11.733 1.63409 11.5574 1.32153 11.2449C1.00897 10.9323 0.833374 10.5084 0.833374 10.0663C0.833374 9.62431 1.00897 9.20039 1.32153 8.88783C1.63409 8.57527 2.05801 8.39967 2.50004 8.39967H2.57504C2.85087 8.39322 3.11838 8.30394 3.34279 8.14343C3.5672 7.98293 3.73814 7.75862 3.83337 7.49967C3.9443 7.24833 3.97739 6.96951 3.92838 6.69918C3.87936 6.42886 3.75049 6.17941 3.55837 5.98301L3.50837 5.93301C3.35341 5.77822 3.23048 5.59441 3.14661 5.39208C3.06273 5.18974 3.01956 4.97287 3.01956 4.75384C3.01956 4.53482 3.06273 4.31794 3.14661 4.11561C3.23048 3.91328 3.35341 3.72946 3.50837 3.57467C3.66316 3.41971 3.84698 3.29678 4.04931 3.21291C4.25164 3.12903 4.46852 3.08586 4.68754 3.08586C4.90657 3.08586 5.12344 3.12903 5.32577 3.21291C5.5281 3.29678 5.71192 3.41971 5.86671 3.57467L5.91671 3.62467C6.11311 3.81679 6.36255 3.94566 6.63288 3.99468C6.90321 4.04369 7.18203 4.0106 7.43337 3.89967H7.50004C7.74652 3.79404 7.95672 3.61864 8.10478 3.39506C8.25285 3.17149 8.3323 2.9095 8.33337 2.64134V2.49967C8.33337 2.05765 8.50897 1.63372 8.82153 1.32116C9.13409 1.0086 9.55801 0.833008 10 0.833008C10.4421 0.833008 10.866 1.0086 11.1786 1.32116C11.4911 1.63372 11.6667 2.05765 11.6667 2.49967V2.57467C11.6678 2.84283 11.7472 3.10482 11.8953 3.3284C12.0434 3.55197 12.2536 3.72737 12.5 3.83301C12.7514 3.94394 13.0302 3.97703 13.3005 3.92801C13.5709 3.879 13.8203 3.75012 14.0167 3.55801L14.0667 3.50801C14.2215 3.35305 14.4053 3.23012 14.6076 3.14624C14.81 3.06237 15.0268 3.0192 15.2459 3.0192C15.4649 3.0192 15.6818 3.06237 15.8841 3.14624C16.0864 3.23012 16.2703 3.35305 16.425 3.50801C16.58 3.6628 16.7029 3.84661 16.7868 4.04894C16.8707 4.25127 16.9139 4.46815 16.9139 4.68717C16.9139 4.9062 16.8707 5.12308 16.7868 5.32541C16.7029 5.52774 16.58 5.71155 16.425 5.86634L16.375 5.91634C16.1829 6.11274 16.0541 6.36219 16.005 6.63252C15.956 6.90285 15.9891 7.18166 16.1 7.43301V7.49967C16.2057 7.74615 16.3811 7.95636 16.6047 8.10442C16.8282 8.25248 17.0902 8.33194 17.3584 8.33301H17.5C17.9421 8.33301 18.366 8.5086 18.6786 8.82116C18.9911 9.13372 19.1667 9.55765 19.1667 9.99967C19.1667 10.4417 18.9911 10.8656 18.6786 11.1782C18.366 11.4907 17.9421 11.6663 17.5 11.6663H17.425C17.1569 11.6674 16.8949 11.7469 16.6713 11.8949C16.4477 12.043 16.2723 12.2532 16.1667 12.4997Z"
                    stroke="#667085"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_4663_6640">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          )}

          {/* TODO: Zoom Integration 
          // Added constraint of companyId and 1 is considered as Gradious */}
          {getDataFromStorage("role") === constants.Roles.super_admin && (
            <CompanyDropDown />
          )}

          {(getDataFromStorage("role") === constants.Roles.admin ||
            getDataFromStorage("role") === constants.Roles.super_admin ||
            getDataFromStorage("role") === constants.Roles.trainer) &&
            parseInt(getDataFromStorage("companyId")) ===
            constants.GRADIOUS_ACCOUNT_ID && (
              <div className="zoom-live-watch">
                <Button
                  size="sm"
                  hierarchy={{
                    type: "tertiaryGrey",
                    buttonText: "Live Proctoring",
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    setShowLive(!showLive);
                    Alert.navigate("/live");
                  }}
                />
                {showLive && <ZoomAdminView showlive={showLive} />}
              </div>
            )}
          {/* TODO: Zoom Integration */}
          <div style={{ marginRight: "5px" }}>
            <ProfileAvatar />
          </div>
        </div>
      </div>
      <Modal
        centered
        show={clearQuestionNotify.isClear}
        style={{
          fontSize: "14px",
          fontWeight: "700",
          lineHeight: "16px",
          fontFamily: "Inter",
          fontstyle: "normal",
        }}
        onHide={() =>
          setClearQuestionNotify({ isClear: false, learnerName: "" })
        }
      >
        <Modal.Body style={{ height: "50px" }}>
          Do you want to clear the questions for{" "}
          {clearQuestionNotify.learnerName}
        </Modal.Body>
        <Modal.Footer style={{ margin: "10px", padding: "0px" }}>
          <Button
            size="sm"
            hierarchy={{ buttonText: "Yes", type: "primary" }}
            onClick={handleClearQuestion}
            style={{ margin: "10px 10px 0 0" }}
          />
          <Button
            size="sm"
            onClick={handleClearQuestion}
            style={{ margin: "10px 10px 0 0" }}
            hierarchy={{ buttonText: "No", type: "teritaryGrey" }}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AdminHeader;
